module.exports = __webpack_public_path__ + "static/media/_MIC2455.image.7a6ce82b.png";